// import useCountries from "../../../hooks/useCountries"
// import { Select } from "../../ui/Select"
// import React from "react"

// export const SelectCountry = React.memo(({label, name, value, onChange, required, disabled, isReport}) => {
//     disabled = disabled || false;
//     const countries = useCountries();

//     return (
//         <div className="form-group">
//             <Select 
//                 label={label}
//                 required={required}
//                 name={name}
//                 value={value}
//                 disabled={disabled}
//                 onChange={onChange}
//                 isReport={isReport}
//                 options={countries.map((value)=>({ value: value, display_value: value }))}
//             />
//         </div>
//     )
// })


// import useCountries from "../../../hooks/useCountries";
// import { Select } from "../../ui/Select";
// import { useTooltips } from "../../../hooks/toolTips"; // 🔍 Ensure this is correct
// import React from "react";

// export const SelectCountry = React.memo(({
//   label,
//   name,
//   value,
//   onChange,
//   required,
//   disabled = false,
//   isReport
// }) => {
//   const countries = useCountries();
//   const tooltips = useTooltips();

//   // ✅ Extract tooltip text using label or name
//   const tooltipText = tooltips?.find(
//     (t) =>
//       (label && t.Label?.toLowerCase() === label.toLowerCase()) ||
//       (name && t.Name?.toLowerCase() === name.toLowerCase())
//   )?.Tooltip;

//   return (
//     <div className="form-group">
//       <Select
//         label={label}
//         name={name}
//         required={required}
//         value={value}
//         disabled={disabled}
//         onChange={onChange}
//         isReport={isReport}
//         options={countries.map((val) => ({
//           value: val,
//           display_value: val,
//         }))}
//         tooltip={tooltipText} // ✅ Injecting tooltip if available
//       />
//     </div>
//   );
// });


import useCountries from "../../../hooks/useCountries";
import { Select } from "../../ui/Select";
import React from "react";
import {SearchableSelect} from "../../ui/SearchableSelectReact";
export const SelectCountry = React.memo(({
  label,
  name,
  value,
  onChange,
  required,
  disabled = false,
  isReport
}) => {
  const countries = useCountries();

  return (
    <div className="form-group">
      <SearchableSelect
        label={label}
        name={name}
        required={required}
        value={value}
        disabled={disabled}
        onChange={onChange}
        isReport={isReport}
        options={countries.map((val) => ({
          value: val,
          display_value: val,
        }))}
      />
    </div>
  );
});
